<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-notice>
            将type属性设置为card即可启用卡片模式。从交互上来说，卡片模式和一般模式的最大区别在于，可以通过直接点击两侧的幻灯片进行切换。
        </ot-notice>
        <ot-row-group :theme="$otTheme" :fixable="false" :flex="false" :code="code">
            <ot-carousel :interval="4000" type="card">
                <ot-carousel-item v-for="item in 'abcd'.split('')" :key="item">
                    <h3>{{ item }}</h3>
                </ot-carousel-item>
            </ot-carousel>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-notice%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%E5%B0%86type%E5%B1%9E%E6%80%A7%E8%AE%BE%E7%BD%AE%E4%B8%BAcard%E5%8D%B3%E5%8F%AF%E5%90%AF%E7%94%A8%E5%8D%A1%E7%89%87%E6%A8%A1%E5%BC%8F%E3%80%82%E4%BB%8E%E4%BA%A4%E4%BA%92%E4%B8%8A%E6%9D%A5%E8%AF%B4%EF%BC%8C%E5%8D%A1%E7%89%87%E6%A8%A1%E5%BC%8F%E5%92%8C%E4%B8%80%E8%88%AC%E6%A8%A1%E5%BC%8F%E7%9A%84%E6%9C%80%E5%A4%A7%E5%8C%BA%E5%88%AB%E5%9C%A8%E4%BA%8E%EF%BC%8C%E5%8F%AF%E4%BB%A5%E9%80%9A%E8%BF%87%E7%9B%B4%E6%8E%A5%E7%82%B9%E5%87%BB%E4%B8%A4%E4%BE%A7%E7%9A%84%E5%B9%BB%E7%81%AF%E7%89%87%E8%BF%9B%E8%A1%8C%E5%88%87%E6%8D%A2%E3%80%82%0A%20%20%20%20%20%20%20%20%3C%2Fot-notice%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%20%3Afixable%3D%22false%22%20%3Aflex%3D%22false%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-carousel%20%3Ainterval%3D%224000%22%20type%3D%22card%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-carousel-item%20v-for%3D%22item%20in%20'abcd'.split('')%22%20%3Akey%3D%22item%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ch3%3E%7B%7B%20item%20%7D%7D%3C%2Fh3%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-carousel-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-carousel%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20lang%3D%22scss%22%20scoped%3E%0A.ot-row-group%20%7B%0A%20%20%20%20text-align%3A%20center%3B%0A%7D%0A.ot-carousel-item%20h3%20%7B%0A%20%20%20%20color%3A%20%23475669%3B%0A%20%20%20%20opacity%3A%200.75%3B%0A%20%20%20%20line-height%3A%2023em%3B%0A%20%20%20%20vertical-align%3A%20middle%3B%0A%20%20%20%20margin%3A%200%3B%0A%7D%0A%0A.ot-carousel-item%3Anth-child(2n)%20%7B%0A%20%20%20%20background-color%3A%20%2399a9bf%3B%0A%7D%0A%0A.ot-carousel-item%3Anth-child(2n%2B1)%20%7B%0A%20%20%20%20background-color%3A%20%23d3dce6%3B%0A%7D%0A%3C%2Fstyle%3E`),
        };
    },
};
</script>

<style lang="scss" scoped>
.ot-row-group {
    text-align: center;
}
.ot-carousel-item h3 {
    color: #475669;
    opacity: 0.75;
    line-height: 23em;
    vertical-align: middle;
    margin: 0;
}

.ot-carousel-item:nth-child(2n) {
    background-color: #99a9bf;
}

.ot-carousel-item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>
